import React, { Fragment } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full min-h-[90vh] flex items-center bg-navy" data-id="element-79">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=2940&auto=format&fit=crop")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-80">
        {/* Gradient overlay: solid dark navy on left, fading slightly to right */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#152a42] via-[#1b3a5b]/90 to-[#1b3a5b]/60" data-id="element-81"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-20" data-id="element-82">
        <div className="max-w-3xl" data-id="element-83">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brandOrange/40 bg-navy-dark/30 backdrop-blur-sm mb-8" data-id="element-84">
            <div className="w-1.5 h-1.5 rounded-full bg-brandOrange" data-id="element-85"></div>
            <span className="text-brandOrange text-[10px] font-bold tracking-[0.15em] uppercase" data-id="element-86">
              {t.hero.eyebrow}
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-[72px] font-poppins font-bold text-white leading-[1.05] tracking-tight mb-6" data-id="element-87">
            {t.hero.title.map((line, i) => <Fragment key={i} data-id="element-88">
                {line}
                {i < t.hero.title.length - 1 && <br data-id="element-89" />}
              </Fragment>)}
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-gray-300 max-w-xl mb-10 leading-relaxed font-inter" data-id="element-90">
            {t.hero.subtitle}
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap items-center gap-4 mb-16" data-id="element-91">
            <Link to="/contact" className="bg-brandOrange hover:bg-brandOrange-hover text-white px-7 py-3.5 rounded font-semibold flex items-center gap-2 transition-colors text-sm" data-id="element-92">
              {t.common.requestConsulting}
              <ArrowRight className="w-4 h-4" data-id="element-93" />
            </Link>
            <Link to="/services" className="bg-white/5 hover:bg-white/10 border border-white/20 text-white px-7 py-3.5 rounded font-semibold transition-colors text-sm" data-id="element-94">
              {t.common.viewServices}
            </Link>
          </div>

          {/* Divider */}
          <div className="h-px w-full max-w-2xl bg-white/10 mb-10" data-id="element-95"></div>

          {/* Inline Stats */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 max-w-2xl" data-id="element-96">
            {t.hero.stats.map((stat, i) => <div key={i} data-id="element-97">
                <div className="text-brandOrange text-3xl font-poppins font-bold mb-1" data-id="element-98">
                  {stat.value}
                </div>
                <div className="text-gray-400 text-[10px] font-bold uppercase tracking-wider" data-id="element-99">
                  {stat.label.map((line, j) => <Fragment key={j} data-id="element-100">
                      {line}
                      {j < stat.label.length - 1 && <br data-id="element-101" />}
                    </Fragment>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}